import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { Footer } from '../../../atoms/Footer/Footer';
import { ContentBody } from '../../../atoms/ContentBody/ContentBody';
import { H1 } from '../../../atoms/Heading/Heading';
import { AwaitingScreenHeader } from '../organisms/molecules/AwaitingScreenHeader/AwaitingScreenHeader';
import { PageView } from '../../../../models/analytics';
import { messages } from '../../../../connectivity/messages';
import { VisuallyHidden } from '../../../../core/atoms/VisuallyHidden/VisuallyHidden.styles';
import { LegalDisclaimer } from '../../../molecules/LegalDisclaimer/LegalDisclaimer';
import { ProviderEntity } from '../../../../models/provider';
import { BackButton } from '../../../organisms/Header/HeaderMolecule';
import { QRCodeContainerWithCorners } from '../../../atoms/QRCodeContainerWithCorners/QRCodeContainerWithCorners';
import { ScreenWrapper } from '../../../atoms/ScreenWrapper/ScreenWrapper';
import { Text } from '../../../atoms/Text/Text';
import { FlexBox } from '../../../atoms/FlexBox/FlexBox';

type AwaitingQrCodeViewProps = {
  provider: ProviderEntity;
  heading: React.ReactNode;
  paymentDetails?: React.ReactNode;
  qrCode: React.ReactNode;
  instructions: React.ReactNode;
  icon?: React.ReactNode;
  view: PageView;
  allowExit: boolean;
} & BackButton;

export const AwaitingQrCodeView = ({
  provider,
  heading,
  qrCode,
  instructions,
  view,
  allowExit,
  paymentDetails,
  onBack,
  icon,
}: AwaitingQrCodeViewProps) => (
  <ScreenWrapper>
    <AwaitingScreenHeader
      pageView={view}
      addBottomMargin={false}
      allowExit={allowExit}
      onBack={onBack}
    />
    <ContentBody>
      <H1>{heading}</H1>
      <Text color="secondary">{instructions}</Text>
      <FlexBox mt="auto" mb="auto" direction="column" alignItems="center">
        <QRCodeContainerWithCorners>
          <FlexBox alignItems="center" as="figure" my="none" mx="none">
            <VisuallyHidden as="figcaption">
              <FormattedMessage {...messages.qrCodeCaption} />
            </VisuallyHidden>
            {qrCode}
          </FlexBox>
        </QRCodeContainerWithCorners>
        {icon && <Box mt="medium">{icon}</Box>}
      </FlexBox>
      {paymentDetails && (
        <Box mb="normal" fullWidth data-testid="payment-details">
          <Footer>{paymentDetails}</Footer>
        </Box>
      )}
    </ContentBody>
    <LegalDisclaimer provider={provider} pageView={view} />
  </ScreenWrapper>
);
